<div class="tour-wrapper" *ngIf="tour" [@fadeInOut]="tour">
  <div class="steps-counter" *ngIf="tour.steps.length > 1">
    <span class="active" [@change]="activeStep">{{ activeStep }}</span
    >/{{ tour.steps.length }}
  </div>
  <step [step]="step" (show)="onShow($event)" (action)="onAction($event)"></step>
  <div class="tour-overlay" [@blink]="blinkAnimation" (@blink.done)="onAnimateDone()"></div>
</div>
